<template>
  <div class="pt-2">
    <!--<vs-divider></vs-divider>-->
    <div class="flex flex-row items-center  justify-end">
      <small class="text-muted mr-1">{{textLabel}}:</small>
      <b-link href="https://securamdata.com" target="_brank">securamdata.com</b-link>
    </div>
    <div class="flex flex-row justify-end items-center pt-1" v-if="showLoginLink">
      <div class="btn btn-outline-primary btn-sm">
        <b-link href="/" target="_self">{{$t('login')}}</b-link>
      </div>
    </div>
  </div>
</template>

<script>

import {
  BLink,
  VBTooltip,
} from 'bootstrap-vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BLink,
    VBTooltip,
  },
  props: {
    textLabel: {
      type: String,
      default: 'Desenvolvido por',
    },
    showLoginLink: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
